import template from './grid.html';
import {GridController} from './grid.controller.js';


const GridComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: GridController,
    controllerAs: 'vm',
    bindings: {
        items: '<',
        onDblClick: '&',
        onDelete: '&'
    }
};

export {GridComponent};



// WEBPACK FOOTER //
// ./app/components/pristanak/grid/grid.js